import Styles from "./Loader.module.scss"
import {ReactComponent as LoaderIcon} from "../../icons/common/loader.svg"

const Loader = () => {
  return (
    <div className={Styles.container}>
        <div className={Styles.icon}>
        <LoaderIcon/>
        </div>
    </div>
  )
}

export default Loader
